<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">

        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Appointments</h3>
            </div>
            <div class="col-auto text-right">
              <a style="display: none" class="btn btn-white filter-btn" href="javascript:void(0);" id="filter_search"
                 @click="toggleShowFilters">
                <i class="fas fa-filter"></i>
              </a>
              <button style="display: none" v-if="showAddAppointmentButton" class="btn btn-primary add-button ml-3"
                      data-toggle="modal" href="#create_appointment_modal">
                <i class="fas fa-plus"></i>
              </button>
              <button @click="navigateToAppointmentCreate"
                      v-if="this.$i18n.locale === 'medical' && showButtonFor('APPOINTMENT_CREATE')"
                      :disabled="isDisabledFor('APPOINTMENT_CREATE')" :title="buttonTooltip('APPOINTMENT_CREATE')"
                      class="btn btn-primary ml-3 first-button" data-toggle="modal">
                <i class="fas fa-plus"></i> Book Appointment
              </button>
              <button @click="navigateToAppointmentCreate"
                      v-if="this.$i18n.locale === 'medical' && showButtonFor('APPOINTMENT_CREATE')"
                      :disabled="isDisabledFor('APPOINTMENT_CREATE')" :title="buttonTooltip('APPOINTMENT_CREATE')"
                      class="btn btn-primary second-button" data-toggle="modal">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Search Filter -->
        <div v-if="showFilters" class="card filter-card" id="filter-inputs">
          <div class="card-body pb-0">
            <form>
              <div class="row filter-row">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Name</label>
                    <input class="form-control" type="text" v-model="filters.name">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Email</label>
                    <input class="form-control" type="text" v-model="filters.email">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Phone</label>
                    <input class="form-control" type="text" v-model="filters.phone">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <button class="btn btn-primary btn-block" type="button" @click="retrieveAppointments">Search
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- /Search Filter -->

        <div ref="appointmentsContainer" class="row vld-parent">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-0">
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <select
                          class="input-group-text form-control bg-primary"
                          v-model="selectedSearchFilterId"
                          @change="changeSearchFilter"
                          :required="true">
                          <option
                            v-for="searchFilter in searchFilters"
                            :key="searchFilter"
                            :value="searchFilter"
                            :name="searchFilter"
                            :selected="searchFilter">
                            {{ searchFilter }}
                          </option>
                        </select>
                      </div>
                      <input class="form-control" type="text" v-model="searchValue"
                             @keyup="searchAppointments($event)" placeholder="Search appointments...">
                    </div>
                  </div>
                </div>
                <hr/>
                <div class="table table-responsive">
                  <div>
                    <table id="tblAppointments" class="table table-hover table-center mb-0 datatable"
                           :class="windowWidth < 768 ? 'cards': '-'">
                      <thead style="background-color: ghostwhite">
                      <tr class="text-center">
                        <th scope="col" class="text-left">#ID</th>
                        <th scope="col" class="text-left">Person</th>
                        <th scope="col" class="text-left" hidden>Purpose</th>
                        <th scope="col" class="text-left">Start Date</th>
                        <th scope="col" class="text-left">End Date</th>
                        <th scope="col"
                            :class="{'text-right': !hasViewPermission && !isMobileView && !displayDisabledButtons, 'text-left': hasViewPermission || isMobileView || displayDisabledButtons}">
                          Status
                        </th>
                        <th class="text-right" v-if="hasViewPermission || displayDisabledButtons">Action</th>
                      </tr>
                      </thead>
                      <tbody v-if="appointments.length">
                      <tr class="text-center clickable-row" v-for="appointment in appointments" :key="appointment.id" @click="viewAppointment(appointment.id)">
                        <td col="#ID: " class="text-left">{{ appointment.code ? appointment.code : '-' }}</td>
                        <td col="Person: " class="text-left">
                          {{
                            appointment.visitor && appointment.visitor.firstName ? getFullName(appointment.visitor.firstName, appointment.visitor.lastName) : getFullName(appointment.firstName, appointment.lastName)
                          }}
                        </td>
                        <td col="Purpose: " class="text-left" hidden>
                          {{ appointment.purposeOfVisit ? appointment.purposeOfVisit : '-' }}
                        </td>
                        <td col="Start Date: " class="text-left">{{
                            appointment.startDateTime ? utcDateToLocal(appointment.startDateTime) : '-'
                          }}
                        </td>
                        <td col="End Date: " class="text-left">
                          {{ appointment.endDateTime ? utcDateToLocal(appointment.endDateTime) : '-' }}
                        </td>
                        <td col="Status: "
                            :class="{'text-right': !hasViewPermission && !isMobileView && !displayDisabledButtons, 'text-left': hasViewPermission || isMobileView || displayDisabledButtons}">
                          <label v-if="appointment.status === 'BOOKED'" class="badge bg-info-light"
                                 style="color: white">BOOKED</label>
                          <label v-else-if="appointment.status === 'POSTPONED'" class="badge bg-warning-light"
                                 style="color: white">POSTPONED</label>
                          <label v-else-if="appointment.status === 'DONE'" class="badge badge-success"
                                 style="color: white">DONE</label>
                          <label v-else-if="appointment.status === 'CANCELLED'" class="badge badge-secondary"
                                 style="color: white">CANCELLED</label>
                          <label v-else class="badge bg-info-light" style="color: white"> {{
                              appointment.status
                            }} </label>
                        </td>
                        <td class="text-right text-white" v-if="hasViewPermission || displayDisabledButtons">
                          <a class="btn btn-success" id="showEditAppointmentModal" data-toggle="modal"
                             href="#edit_appointment_modal" hidden></a>
                          <button v-if="showButtonFor('APPOINTMENT_READ')" :disabled="isDisabledFor('APPOINTMENT_READ')"
                                  :title="buttonTooltip('APPOINTMENT_READ')" @click.stop="viewAppointment(appointment.id)"
                                  class="btn btn-sm bg-success-light" :class="windowWidth < 768 ? 'btn btn-block': '-'">
                            <i class="fa fa-eye mr-1"></i> View
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div v-if="!appointments.length" class="text-center mt-5 mb-5">
                      <div v-if="!isLoading">You don't have any appointments yet!</div>
                    </div>
                  </div>
                </div>

                <div v-if="appointments.length" class="row">
                  <div class="col-sm-12 col-md-5">
                    <div class="" id="tblProducts_info" appointment="status" aria-live="polite"
                         style="padding-top: 1.25em">
                      Show
                      <select @change="onChangeRecordsPerPage" v-model="recordsPerPage">
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                      </select>
                      of {{ totalRecords }} entries
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-7">
                    <div class="dataTables_paginate paging_simple_numbers" id="tblProducts_paginate"
                         style="padding-top: 0.55em">
                      <pagination
                        :totalPages="totalPages"
                        :perPage="recordsPerPage"
                        :currentPage="currentPage"
                        @pagechanged="onPageChange"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Create Appointment Modal -->
        <div class="modal fade" id="create_appointment_modal" aria-hidden="true" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Create Appointment</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <!-- <CreateMedicalAppointmentForm :caseId="caseId" :customerId="customerId"
                                              ref="createMedicalAppointmentForm"/> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Create Appointment Modal -->

        <!-- Edit Appointment Modal -->
        <div class="modal fade" id="edit_appointment_modal" aria-hidden="true" role="dialog" ref="modal">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Edit Appointment</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form action="">
                  <div>
                    <div class="form-group">
                      <label>Appointment Number</label>
                      <input readonly type="text" class="form-control" v-model="appointment.number"
                             ref="appointmentNumber" placeholder="">
                    </div>
                    <div class="form-group">
                      <label class="required">Name</label>
                      <input type="text" class="form-control" v-model="appointment.name">
                    </div>
                    <div class="form-group">
                      <label>Email</label>
                      <input type="text" class="form-control" v-model="appointment.email">
                    </div>
                    <div class="form-group">
                      <label>Phone</label>
                      <input type="text" class="form-control" v-model="appointment.phone">
                    </div>
                    <div class="form-group">
                      <label>Address</label>
                      <input type="text" class="form-control" v-model="appointment.address">
                    </div>
                    <div class="mt-4">
                      <button class="btn btn-primary btn-block" @click="updateAppointment($event)">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Edit Appointment Modal -->
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import appointmentService from "../../service/appointment.service";
import Pagination from "../Pagination";
import moment from "moment";
import {convertToLocalDate, convertToLocalTime, getFullName, utcDateToLocal} from "../../utils/utils";
import {getConfig} from "../../utils/config";
import permissionService from "../../service/permission.service";

export default {
  name: "appointments-list",
  components: {
    Pagination,
    // CreateMedicalAppointmentForm,
  },
  data() {
    return {
      appointmentId: null,
      appointment: {},
      appointments: [],
      showFilters: false,
      currentIndex: -1,
      searchValue: undefined,
      title: undefined,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 25,
      filters: {
        name: null,
        email: null,
        phone: null
      },
      searchFilters: ["Code", "Status"],
      selectedSearchFilterId: "Code",
      permissions: [],
      fullPage: false,
      showAddAppointmentButton: false,
      caseId: undefined,
      customerId: undefined,
      isLoading: false,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
      displayDisabledButtons: !getConfig().hideIfNoPermission
    };
  },
  methods: {
    navigateToAppointmentCreate() {
      this.$router.push('/appointments/create')
    },
    getFullName: getFullName,
    formatToDate(date) {
      return moment(date).format("YYYY-MM-DD")
    },
    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm")
    },
    formatTime(time) {
      return moment(time).format("HH:mm")
    },
    editAppointment(id) {
      this.appointmentId = id
      this.retrieveAppointment(id)
      document.getElementById('showEditAppointmentModal').click()
    },
    retrieveAppointment(id) {
      appointmentService.findById(localStorage.getItem('mid'), id)
        .then(response => {
          this.appointment = response.data.data;
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', 'Oops', "Error occurred")
        });
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    changeSearchFilter() {
      this.searchAppointments(null)
    },
    searchAppointments(e) {
      e ? e.preventDefault() : null
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.appointmentsContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      
      const context = JSON.parse(localStorage.getItem('selectedContext'));
      if (!context || !context.contextId) {
        this.fireNotification('error', "Customer context not found", 5000);
        loader.hide();
        return;
      }
      
      let params = {
        page: this.currentPage,
        size: this.recordsPerPage,
        op: 'like',
        customerId: context.contextId
      }
      if (this.searchValue) {
        params[this.selectedSearchFilterId.toLowerCase()] = this.searchValue;
      }
      appointmentService.findByCustomerId(localStorage.getItem("mid"), context.contextId, params)
        .then(response => {
          this.appointments = response.data.data;
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          loader.hide()
        })
    },
    retrieveAppointments() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.appointmentsContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
      this.isLoading = true
      
      const context = JSON.parse(localStorage.getItem('selectedContext'));
      if (!context || !context.contextId) {
        this.fireNotification('error', "Customer context not found", 5000);
        this.isLoading = false;
        loader.hide();
        return;
      }
      
      const params = {
        mid: localStorage.getItem("mid"),
        page: this.currentPage,
        size: this.recordsPerPage,
        customerId: context.contextId
      }
      appointmentService.findByCustomerId(localStorage.getItem("mid"), context.contextId, params)
        .then(response => {
          this.appointments = response.data.data;
          this.totalPages = response.data.pagination.totalPages
          this.totalRecords = response.data.pagination.totalRecords
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('warning', "Oops", "Error occurred")
        })
        .finally(() => {
          this.isLoading = false
          loader.hide()
        });
    },
    utcDateToLocal: utcDateToLocal,
    convertToLocalDate(utcDate, utcTime) {
      return convertToLocalDate(utcDate, utcTime)
    },
    convertToLocalTime(utcDate, utcTime) {
      return convertToLocalTime(utcDate, utcTime)
    },
    updateAppointment(e) {
      e.preventDefault();
      let appointment = {
        name: this.appointment.name,
        phone: this.appointment.phone,
        email: this.appointment.email,
        address: this.appointment.address,
        status: "ACTIVE",
      };
      appointmentService.update(localStorage.getItem('mid'), this.appointmentId, appointment)
        .then(response => {
          let success = response.data.success;
          if (success === true) {
            this.appointment = response.data.data;
            document.getElementById('showEditAppointmentModal').click()
            this.retrieveAppointments()
            Swal.fire({
              icon: 'success',
              title: 'Done',
              text: "Successfully updated",
              footer: '<a href="">Why do I have this issue?</a>'
            })
          } else {
            this.fireNotification('error', "Oops", response.data.narrative)
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Oops", "Error occurred")
        });
    },
    deleteAppointment(appointmentId) {
      appointmentService.delete(localStorage.getItem('mid'), appointmentId)
        .then(response => {
          let success = response.data.success;
          if (success) {
            this.success = true;
            this.appointments = this.appointments.filter(function (item) {
              return item.id !== appointmentId;
            });
            this.fireNotification('success', "Deleted", "Successfully deleted")
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.narrative,
              footer: '<a href="">Why do I have this issue?</a>'
            })
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        });
    },
    onPageChange(page) {
      this.currentPage = page
      this.retrieveAppointments()
    },
    onChangeRecordsPerPage() {
      this.retrieveAppointments()
    },
    viewAppointment(id) {
      this.$router.push(`/appointments/${id}`);
    },
    fireNotification(icon, message, timeout) {
      Swal.fire({
        toast: true,
        width: 300,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: timeout,
        timerProgressBar: true,
      })
    },
    showButtonFor(permission) {
      return true
    },
    isDisabledFor(permission) {
      return false
    },
    buttonTooltip(permission) {
      return ''
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    hasViewPermission() {
      return true
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },
    basedOnWindowWidth() {
      if (windowWidth < 768) {
        return true
      }
      return false
    }
  },

  watch: {
    "caseId": {
      handler() {
        this.$refs.caseId = this.caseId
      }
    },
    windowWidth: function () {
      if (this.windowWidth < 768) {
        return this.isMobileView = true
      } else if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        return this.isTabletView = true
      } else {
        return this.isDesktopView = true
      }
    }
  },
  async mounted() {
    if (!this.currentUser) {
      this.$router.push('/login')
      return
    }

    this.retrieveAppointments();
    this.customerId = this.$route.query.customerId;
    this.caseId = this.$route.query.caseId;

  }
}
</script>
<style>
:disabled {
  cursor: not-allowed
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}

.second-button {
  display: none !important;
}

@media (max-width: 768px) {
  .first-button {
    display: none !important;
  }

  .second-button {
    display: inline-block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/appointments/AppointmentList.vue